import "./App.css";
import { Routes, Route } from "react-router";
import Dashboard from "../src/dashboard/Dashboard";
import LoginPage from "./Auth/Login";
import OurTeam from "./components/Ourteam";
import LandingLayout from "./components/LandingLayout";
import MissionVision from "./components/MissionVision";
import LandingPage01 from "./components/LandingPage01";
import History from "./components/History";
import { PermissionProvider } from "./context/PermissionContext";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <PermissionProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        style={{ top: "70px", right: "16px", zIndex: 99999 }}
      />
      <div className="App">
        <Routes>
          <Route element={<LandingLayout />}>
            <Route path="/" element={<LandingPage01 />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/history" element={<History />} />
            <Route path="/mission-vision" element={<MissionVision />} />
          </Route>

          {/* Standalone pages — no landing navbar */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Routes>
      </div>
    </PermissionProvider>
  );
}

export default App;
